import { colors } from '_/config/theme';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, Text } from 'react-native';

interface CheckVisitorIsForeignerProps {
  onClick: (value: boolean) => void;
  buttonKey: string;
  foreignerDocumentSelected: boolean;
}

const CheckVisitorIsForeigner: React.FC<CheckVisitorIsForeignerProps> = ({
  onClick,
  buttonKey,
  foreignerDocumentSelected,
}) => {
  const { t } = useTranslation();

  return foreignerDocumentSelected ? (
    <Text style={styles.textStyles}>
      {t('foreignerDocument.part.4', { defaultValue: 'Se você' })}{' '}
      <Text style={styles.link} onPress={() => onClick(false)}>
        {t('foreignerDocument.part.5', { 
          buttonKey,
          defaultValue: 'possui {{buttonKey}}, clique aqui'
        })}
      </Text>
      {'\n'}
      {t('foreignerDocument.part.6', { defaultValue: 'para fazer o check-in' })}
    </Text>
  ) : (
    <Text style={styles.textStyles}>
      <Text>{t('foreignerDocument.part.1', { defaultValue: 'Se você é um estrangeiro e você' })}{' '}</Text>
      <Text style={styles.link} onPress={() => onClick(true)}>
        {t('foreignerDocument.part.2', {
          buttonKey,
          defaultValue: 'não possui {{buttonKey}}, clique aqui',
        })}
      </Text>
      {'\n'}
      {t('foreignerDocument.part.3', { defaultValue: 'para fazer o check-in com o seu número de passaporte' })}
    </Text>
  );
};
export default CheckVisitorIsForeigner;

const styles = StyleSheet.create({
  textStyles: {
    fontSize: 16,
    marginTop: 40,
    width: '100%',
    textAlign: 'center',
    lineHeight: 22,
  },
  link: {
    color: colors.secondary,
    fontWeight: 'bold',
    textAlign: 'center',
  },
});
